import React from "react";

const Expand = () => {
  return (
    <svg
      width="6"
      height="7"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.89844 8.93359H6.76758C7.77832 8.93359 8.3584 8.35352 8.3584 7.35156V2.54395C8.3584 1.99902 7.94531 1.58594 7.3916 1.58594C6.84668 1.58594 6.44238 1.99023 6.44238 2.54395V3.16797L6.62695 5.93652L4.57031 3.76562L2.03906 1.2168C1.86328 1.03223 1.62598 0.944336 1.37109 0.944336C0.782227 0.944336 0.360352 1.33984 0.360352 1.92871C0.360352 2.19238 0.457031 2.43848 0.641602 2.62305L3.19043 5.16309L5.35254 7.21094L2.5752 7.02637H1.89844C1.35352 7.02637 0.94043 7.42188 0.94043 7.97559C0.94043 8.53809 1.34473 8.93359 1.89844 8.93359ZM10.5557 17.8281C11.1094 17.8281 11.5049 17.4326 11.5049 16.8789V16.167L11.3203 13.4072L13.377 15.5693L15.9609 18.1709C16.1367 18.3555 16.374 18.4521 16.6289 18.4521C17.2178 18.4521 17.6396 18.0479 17.6396 17.459C17.6396 17.1953 17.543 16.9492 17.3584 16.7646L14.7656 14.1807L12.5947 12.124L15.3721 12.3086H16.1367C16.6816 12.3086 17.0947 11.9131 17.0947 11.3594C17.0947 10.8057 16.6904 10.4014 16.1367 10.4014H11.1797C10.1777 10.4014 9.59766 10.9902 9.59766 11.9922V16.8789C9.59766 17.4238 10.002 17.8281 10.5557 17.8281Z"
        fill="#797979"
      />
    </svg>
  );
};

export default Expand;
